module.exports = __webpack_public_path__ + "img/MUR.e4a16955.svg";